<template>
  <div>
    <vue-form
      class="form-horizontal form-validation"
      :state="formstate"
      @submit.prevent="onSubmit"
    >
      <b-row class="toolbar-ptc">
        <b-col>
          <router-link
            :to="{
              name: 'coupon_give_list',
              params: {
                queryTab1: $route.params.queryTab1,
                queryTab2: $route.params.queryTab2,
                collapse: $route.params.collapse,
                modelTab: $route.params.modelTab,
              },
            }"
            class="btn btn-ptc1"
            tag="button"
            >返回</router-link
          >
        </b-col>
        <b-col class="text-center title">點數兌換券上架 / 商品券贈送 / 新增</b-col>
        <b-col class="text-right">
          <button type="submit" class="btn btn-save">儲存</button>
        </b-col>
      </b-row>
      <div id="func-content">
        <div class="contact-page">
          <div class="col-lg-12">
            <b-card class="bg-warning-card">
              <div class="row">
                <b-container fluid>
                  <form>
                    <div class="row mb-3">
                      <label class="control-label col-md-3"
                        >推播顯示文字：</label
                      >
                      <div class="col-md-7">
                        <validate tag="div">
                          <input
                            type="text"
                            name="Input_GiveName"
                            class="form-control"
                            v-model.trim="GiveName"
                            placeholder="請輸入推播顯示文字"
                            maxlength="30"
                            :required="toSendMessage"
                          />
                          <field-messages
                            name="Input_GiveName"
                            show="$invalid && $submitted"
                            class="text-danger"
                          >
                            <div slot="required">請輸入推播顯示文字</div>
                          </field-messages>
                        </validate>
                      </div>
                    </div>
                    <div class='row mb-3' v-if="GiveType=='3' || GiveType=='4' || GiveType=='5'">
                      <label class='control-label col-md-3'>是否發推播：</label>
                      <div class='col-md-9'>
                        <toggle-button v-model="toSendMessage" :sync="true" :height=30 :width=60
                        style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}"/>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label class="control-label col-md-3">贈送條件：</label>
                      <div class="col-md-4">
                        <validate tag="div">
                          <select
                            id="GiveType"
                            name="GiveType"
                            class="form-control"
                            v-model="GiveType"
                            required
                            @change="ChgMinDate()"
                          >
                            <option value="">請選擇</option>
                            <option value="1">新加入會員</option>
                            <option value="2">生日禮</option>
                            <option value="3">所有正式會員</option>
                            <option value="4">單一會員</option>
                            <option value="5">會員資料匯入</option>
                          </select>
                          <field-messages
                            name="GiveType"
                            show="$invalid && $submitted"
                            class="text-danger"
                          >
                            <div slot="required">請選擇贈送條件</div>
                          </field-messages>
                        </validate>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label
                        v-show="GiveType == ''"
                        class="control-label col-md-3"
                        >受贈區間：</label
                      >
                      <label
                        v-show="GiveType == '1'"
                        class="control-label col-md-3"
                        >受贈會員入會區間：</label
                      >
                      <label
                        v-show="GiveType == '2'"
                        class="control-label col-md-3"
                        >受贈會員生日月份區間：</label
                      >
                      <label
                        v-show="GiveType == '3' || GiveType == '5'"
                        class="control-label col-md-3"
                        >預約贈送日:</label
                      >
                      <div class="col-md-3" v-show="GiveType != '3' && GiveType != '5' && GiveType != '4'">
                        <validate tag="div">
                          <input
                            v-show="GiveType != '2'"
                            type="date"
                            name="Input_sale_sdate"
                            class="form-control"
                            v-model="sale_sdate"
                            @change="ChgTicket()"
                            :min="min_sdate"
                            :max="max_date"
                            required
                          />
                          <input
                            v-show="GiveType == '2'"
                            type="text"
                            class="form-control"
                            v-model="sale_smon"
                            @change="ChgTicket()"
                          />
                          <field-messages
                            name="Input_sale_sdate"
                            show="$invalid && $submitted"
                            class="text-danger"
                          >
                            <div v-if="v_SaleDate" slot="required">
                              &nbsp;請輸入正確的日期格式(起)
                            </div>
                          </field-messages>
                          <div
                            class="text-danger"
                            style="padding: 0.3rem"
                            v-if="v_SaleDate === false"
                          >
                            {{ this.v_DateMsg }}
                          </div>
                        </validate>
                      </div>
                      <label v-show="GiveType != '3' && GiveType != '5' && GiveType != '4'" class="control-label"
                        >至</label
                      >
                      <div class="col-md-3" v-show="GiveType != '4'">
                        <validate tag="div">
                          <input
                            v-show="GiveType != '2'"
                            type="date"
                            name="Input_sale_edate"
                            class="form-control"
                            v-model="sale_edate"
                            :min="min_edate"
                            :max="max_date"
                            @change="ChgTicket()"
                            required
                          />
                          <input
                            v-show="GiveType == '2'"
                            type="text"
                            class="form-control"
                            v-model="sale_emon"
                            @change="ChgTicket()"
                          />
                          <field-messages
                            name="Input_sale_edate"
                            show="$invalid && $submitted"
                            class="text-danger"
                          >
                            <div slot="required">請輸入正確的日期格式(迄)</div>
                          </field-messages>
                          <div
                            class="text-danger"
                            style="padding: 0.3rem"
                            v-if="v_SaleDateE === false"
                          >
                            結束日需大於系統日
                          </div>
                        </validate>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label class="control-label col-md-3">贈送票券：</label>
                      <div class="col-md-7">
                        <validate tag="div">
                          <select
                            id="select_Ticket"
                            name="select_Ticket"
                            class="form-control"
                            v-model="Ticket"
                            required
                          >
                            <option disabled value="">請選擇</option>
                            <option
                              v-for="x in ListTicket"
                              v-bind:value="x.ID"
                              :key="x.ID"
                            >
                              {{ x.Code }} {{ x.Name }}
                            </option>
                          </select>
                          <field-messages
                            name="select_Ticket"
                            show="$invalid && $submitted"
                            class="text-danger"
                          >
                            <div slot="required">請選擇票券類別</div>
                          </field-messages>
                        </validate>
                      </div>
                    </div>
                    <div class="row mb-3" v-if="GiveType=='4'">
                      <label class="control-label col-md-3">會員手機號碼：</label>
                      <div class="col-md-7">
                        <validate tag="div">
                          <input type='phone' name="Input_Mobile" maxlength="10" v-model='mobile' class='form-control' id='mobile' placeholder='請輸入會員電話' v-on:keyup="checkMobile($event)" required/>
                        </validate>
                        <field-messages
                            name="Input_Mobile"
                            show="$invalid && $submitted"
                            class="text-danger"
                        >
                          <div slot="required">請輸入手機號碼</div>
                        </field-messages>
                        <div
                          class="text-danger"
                          v-if="v_Mobile !== '' && mobile !== ''"
                          >
                          {{ this.v_Mobile }}
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3" v-if="GiveType=='5'">
                      <label class="control-label col-md-3">上傳會員名單：</label>
                      <div class="col-md-7">
                        <validate tag="div">
                          <input hidden type="file" name="Input_MemberList" ref="fileInput" id="memberList" accept=".csv" @change="handleFileUpload()">
                          <i class="fa fa-question-circle" style="cursor: pointer;" @click="$refs.importFileDesc.show()"></i>
                          <button type="button" class="btn btn-warning text-white ml-2" @click="() => {this.$refs.fileInput.click()}">{{ this.fileName == '' ? '請選擇會員名單': this.fileName }}</button>
                          <span class="text-danger pl-3" v-if="memberAmount > 0">
                            已匯入{{this.memberAmount}}筆會員資料
                          </span>
                          <button type="button" class="btn btn-primary text-white ml-2" @click="resetFile()" v-if="v_MemberList">清除</button>
                        </validate>
                      </div>
                    </div>
                    <div class='row mb-3' v-if="GiveType=='3' || GiveType=='4' || GiveType=='5'">
                      <label class="control-label col-md-3"
                        >活動名稱：</label
                      >
                      <div class="col-md-7">
                        <validate tag="div">
                          <input
                            type="text"
                            name="Input_GiveGroupName"
                            class="form-control"
                            v-model.trim="GiveGroupName"
                            placeholder="請輸入活動名稱"
                            maxlength="30"
                          />
                        </validate>
                      </div>
                    </div>

                  </form>
                </b-container>
              </div>
            </b-card>
            <div class="row mb-3 text-danger " style="margin:30px">
            <label v-show="GiveType == '1'" class="control-label col-md-12"
              >開始日至結束日為贈送對象，該入會區間的日期為升級正式會員當日</label
            >
            <label v-show="GiveType == '2'" class="control-label col-md-12"
              >僅可新增下個月份開始的生日禮活動，符合上述區間之月份生日者於當月5日，都可收到票券</label
            >
            <label v-show="GiveType == '3' ||GiveType == '5' " class="control-label col-md-12"
              >贈送對象為今日前(不含今日)正式會員</label
            >
          </div>
          </div>

        </div>
      </div>
    </vue-form>
    <!-- 匯入檔案說明 -->
    <b-modal ref="importFileDesc" hide-footer title="匯入檔說明">
      <pre class="mb-0" style="font-size:16px">
  檔案格式
  1. 僅限csv檔。
  2. 檔名不限。

  內容限制
  1.僅需輸入手機號碼。
  2.限定每行為10碼數字。
  3.不可有空行(含最後一行)。
  4.會員手機號碼筆數上限為一萬筆。
      </pre>
      <img src="/static/pushMemberImportSample.png" class="img-fluid"/>
    </b-modal>
    <b-modal size='lg' ref="invalidWindow" hide-footer title="檔案解析錯誤詳情">
      <div class="row">
        <div class="col-lg-12">
          <div class="p-4 box-shadow" header="Form Elements">
            <table id="mytable" class="table table-bordred table-striped mt-3 table-break">
              <thead>
                  <tr>
                      <th width="15%">項次</th>
                      <th width="15%">列次</th>
                      <th width="35%">內容</th>
                      <th width="35%">錯誤原因</th>
                  </tr>
                  <tr v-for="v in showInvalidList" :key="v.seq">
                      <td>{{v.seq}}</td>
                      <td>{{v.rowNumber}}</td>
                      <td>「{{v.content}}」</td>
                      <td>
                        {{
                          (v.reason) == 1 ? '內容為空值':
                          (v.reason) == 2 ? '內容不符合手機格式':
                          (v.reason) == 3 ? '重複的手機號碼':
                          (v.reason) == 4 ? '會員等級非正式會員':
                          (v.reason) == 5 ? '該會員未存在資料庫中': '未知的錯誤請通知管理員'
                        }}
                      </td>
                  </tr>
              </thead>
            </table>
            <div>
                <div class="row" style="padding: 0 1rem">
                    <b-pagination size="md" :total-rows="model1.totalrows" v-model="model1.currentPage" :per-page="model1.rows" @change="getInvalidList"></b-pagination>
                    <label style="margin:8px">{{model1.startRowNum}}到{{model1.endRowNum}}，總共 {{model1.totalrows}}筆</label>
                </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import ToggleButton from 'vue-js-toggle-button'
import axios from 'axios'
import { API_URL } from '@/store/root.js'
// for 訊息視窗
import miniToastr from 'mini-toastr'
miniToastr.init()
Vue.use(ToggleButton)
export default {
  data () {
    return {
      formstate: {}, // 驗證用
      min_sdate: '', // 可選的最小日期
      min_edate: '', // 可選的最小日期
      max_date: '9999-12-31', // 可選的最大日期
      v_SaleDate: true, // 檢核贈送期間
      v_SaleDateE: true,
      v_DateMsg: '',
      GiveType: '', // 贈送條件 (1:新加入會員, 2:生日禮,3:所有正式會員, 4:單一會員, 5:多會員, 6:店長系統)
      toSendMessage: true,
      GiveName: '', // 推播顯示文字
      GiveGroupName: '', // 分組活動名稱
      Ticket: '', // 贈券票券
      sale_sdate: '', // 贈送期間
      sale_edate: '', // 贈送期間
      sale_smon: '',
      sale_emon: '',
      ListTicket: [], // 票券下拉
      mobile: '',
      v_Mobile: '',
      memberList: [],
      invalidList: [],
      showInvalidList: [],
      fileName: '',
      memberAmount: 0,
      v_MemberList: false,
      model1: {
        currentPage: 1,
        totalrows: 0,
        rows: 10,
        startRowNum: 0,
        endRowNum: 0
      }
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F31') // 功能權限 帶入功能代碼
    if (this.FunctionPermission >= 2) {
      this.ChgMinDate()
      this.load()
    } else {
      if (this.FunctionPermission === 1) {
        this.$router.push({ name: 'coupon_give_list' })
      } else {
        this.$router.push({ name: 'name' })
      }
    }
  },
  methods: {
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    load () {},
    onSubmit: function () {
      if (this.GiveType === '2') {
        if (!this.CheckDateTime(this.sale_smon)) {
          miniToastr.error('起始月份格式錯誤')
          return
        }

        if (
          new Date(this.sale_smon.replace('/', '-') + '-01').getMonth() <
          new Date(this.min_sdate).getMonth() &&
          new Date(this.sale_smon.replace('/', '-') + '-01').getFullYear() <=
          new Date(this.min_sdate).getFullYear()
        ) {
          miniToastr.error('起始月份應大於本月')
          return
        }

        if (!this.CheckDateTime(this.sale_emon)) {
          miniToastr.error('結束月份格式錯誤')
          return
        }

        if (
          new Date(this.sale_emon.replace('/', '-') + '-01').getMonth() <
          new Date(this.min_sdate).getMonth() &&
          new Date(this.sale_emon.replace('/', '-') + '-01').getFullYear() <=
          new Date(this.min_sdate).getFullYear()
        ) {
          miniToastr.error('結束月份應大於本月')
          return
        }
      }
      // 檢核上架期間
      if (this.sale_edate !== '' && this.sale_edate <= this.nowDate()) {
        this.v_SaleDateE = false
        this.v_SaleDate = true
        this.v_DateMsg = '贈送日需大於系統日'
      } else if (this.sale_sdate !== '' && this.sale_edate !== '') {
        if (this.sale_sdate > this.sale_edate) {
          this.v_SaleDateE = true
          this.v_SaleDate = false
          this.v_DateMsg = '起始日不可大於結束日'
        } else if (this.GiveType === '1' && this.sale_sdate <= this.nowDate()) {
          this.v_SaleDateE = true
          this.v_SaleDate = false
          this.v_DateMsg = '起始日需大於系統日'
        } else {
          this.v_SaleDateE = true
          this.v_SaleDate = true
        }
      }
      // 單一會員贈券
      if (this.GiveType === '4') {
        // 此類型不需檢測日期
        this.v_SaleDateE = true
        this.v_SaleDate = true
      }
      if (
        this.formstate.$invalid ||
        this.v_SaleDate === false ||
        this.v_SaleDateE === false ||
        this.v_Mobile !== '' ||
        (this.GiveType === '5' && this.v_MemberList === false)
      ) {
        this.$parent.verificationErrMsg()
      } else {
        this.add()
      }
    },
    add () {
      this.$parent.Loading = true
      var sendMessage = true
      if (this.GiveType === '3' || this.GiveType === '4' || this.GiveType === '5') {
        sendMessage = this.toSendMessage
      }
      return axios
        .post(API_URL + '/web/ticketGive/create', {
          giveType: Number(this.GiveType),
          name: this.GiveName,
          giftCertificateID: this.Ticket,
          sdate: this.sale_sdate.replace(/-/g, ''),
          edate: this.sale_edate.replace(/-/g, ''),
          toSendMessage: sendMessage,
          mobile: this.mobile,
          mobiles: this.memberList,
          groupName: this.GiveGroupName
        })
        .then((response) => {
          switch (response.data.result) {
            case '0000':
              miniToastr.success('新增成功')
              this.$router.push({
                name: 'coupon_give_list',
                params: {
                  queryTab1: this.$route.params.queryTab1,
                  queryTab2: this.$route.params.queryTab2,
                  collapse: this.$route.params.collapse,
                  modelTab: this.$route.params.modelTab
                }
              })
              break
            case '0006':
              this.$parent.logOut(false, true)
              break
            case '1503':
              this.resetFile()
              this.invalidList = response.data.invalidMobiles.sort((a, b) => a.rowNumber - b.rowNumber)
              this.model1.totalrows = this.invalidList.length
              this.invalidList = this.invalidList.map((item, index) => {
                item.seq = index + 1
                return item
              })
              this.$refs.invalidWindow.show()
              this.getInvalidList(1)
              miniToastr.error(response.data.message, '錯誤訊息')
              break
            default:
              miniToastr.error(response.data.message, '錯誤訊息')
              break
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })
        .finally(() => {
          this.$parent.Loading = false
        })
    },
    ChgTicket: function () {
      var date = new Date()
      var year = 0
      var mon = 0
      var day = 0
      var hours = date.getHours().toString().padStart(2, '0')
      var minutes = date.getMinutes().toString().padStart(2, '0')
      var saleStime = '000000'
      var saleEtime = '235959'
      switch (this.GiveType) {
        case '2':
          if (this.CheckDateTime(this.sale_smon)) {
            this.sale_sdate = this.sale_smon.replace('/', '-') + '-01'
          }

          if (this.CheckDateTime(this.sale_emon)) {
            var eMon = this.sale_emon.replace('/', '-') + '-01'
            date = new Date(eMon)
            date.setMonth(date.getMonth() + 1)
            date.setDate(date.getDate() - 1)
            year = date.getFullYear()
            mon = date.getMonth() + 1
            if (mon < 10) {
              mon = '0' + mon
            }
            day = date.getDate()
            if (day < 10) {
              day = '0' + day
            }

            this.sale_edate = year + '-' + mon + '-' + day
          }
          break
        case '5':
        case '3':
          this.sale_sdate = this.nowDate()
          saleStime = hours + minutes + '00'
          break
        case '4':
          const formatedDate = this.nowDate()
          // 獲取票券後端 API 搜索票券邏輯
          // 使用開始日 小於等於DATE
          // 使用結束日 大於等於DATE
          this.sale_sdate = formatedDate
          this.sale_edate = formatedDate
          saleStime = hours + minutes + '00'
          saleEtime = hours + minutes + '59'
          break
      }

      if (this.sale_sdate !== '' && this.sale_edate !== '') {
        return axios
          .post(API_URL + '/web/ticketGive/ticketList', {
            sdate: this.sale_sdate.replace('-', '').replace('-', '') + saleStime,
            edate: this.sale_edate.replace('-', '').replace('-', '') + saleEtime
          })
          .then((response) => {
            if (response.data.result === '0000') {
              this.ListTicket = response.data.data
            } else {
              if (response.data.result === '0006') {
                this.$parent.logOut(false, true)
              } else {
                miniToastr.error(response.data.message, '錯誤訊息')
              }
            }
            this.$parent.Loading = false
          })
          .catch((error) => {
            miniToastr.error(error, '錯誤訊息')
            this.$parent.Loading = false
          })
      }
    },
    ChgMinDate: function () {
      this.toSendMessage = true
      var date = new Date()
      var year = 0
      var mon = 0
      var day = 0

      switch (this.GiveType) {
        case '1':
        case '5':
          date.setDate(date.getDate() + 1)
          year = date.getFullYear()
          mon = date.getMonth() + 1
          day = date.getDate()
          break
        case '2':
          date.setMonth(date.getMonth() + 1)
          year = date.getFullYear()
          mon = date.getMonth() + 1
          day = 1
          break
        case '3':
          date.setDate(date.getDate() + 3)
          year = date.getFullYear()
          mon = date.getMonth() + 1
          day = date.getDate()
          break
      }

      if (mon < 10) {
        mon = '0' + mon
      }

      if (day < 10) {
        day = '0' + day
      }

      this.min_sdate = year + '-' + mon + '-' + day
      this.min_edate = this.min_sdate

      switch (this.GiveType) {
        case '2':
          this.sale_smon = this.min_sdate.substring(0, 7).replace('-', '/')
          this.sale_emon = this.min_sdate.substring(0, 7).replace('-', '/')
          break
        case '5':
        case '3':
          this.min_sdate = this.nowDate()
          break
      }
      if (this.GiveType === '2') {
      }
      this.ChgTicket()
    },
    nowDate: function () {
      var time = new Date()
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var day = time.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    CheckDateTime (mystring) {
      var reg = /^(\d{4})\/(\d{2})$/
      var str = mystring
      if (str === '') return true
      if (!reg.test(str) && RegExp.$2 <= 12 && RegExp.$3 <= 31) {
        return false
      }
      return true
    },
    checkMobile (event) {
      var value = event.target.value
      if (!/^09\d{8}$/.test(value)) {
        this.v_Mobile = '請輸入正確手機號碼格式'
      } else {
        this.v_Mobile = ''
      }
    },
    handleFileUpload: async function () {
      let invalid = false
      const file = this.$refs.fileInput.files[0]
      if (file.size > 1024 * 1024 * 1 || file.name.slice(-4) !== '.csv') {
        miniToastr.error('上傳的會員名單過大')
        invalid = true
      }
      const reader = new FileReader()
      reader.readAsText(file)
      const frdDoneEvent = await new Promise(resolve => { reader.onload = resolve })
      // 過濾換行符號、空白、及空的元素
      const uploadMembers = frdDoneEvent.target.result.split('\n').map(item => item.trim())
      const maxMemberAmount = 10000 // 上限
      if (uploadMembers.length > maxMemberAmount) {
        miniToastr.error(`匯入會員名單超過 ${maxMemberAmount} 筆上限`)
        invalid = true
      }

      // 篩選
      const uniqueMap = new Map()
      this.invalidList = []
      this.model1.totalrows = 0
      let countRows = 0
      uploadMembers.forEach((mobile, index) => {
        let valid = false
        let reason = 0
        if (!mobile) {
          reason = 1
        } else if (!/^09\d{8}$/.test(mobile)) {
          reason = 2
        } else if (uniqueMap.get(mobile)) {
          reason = 3
        } else {
          valid = true
        }
        if (!valid) {
          countRows++
          this.invalidList.push({
            seq: countRows,
            rowNumber: index + 1,
            content: mobile,
            reason: reason
          })
        }
        uniqueMap.set(mobile, true)
      })
      if (countRows > 0) {
        this.model1.totalrows = countRows
        invalid = true
      }
      if (invalid) {
        this.fileName = ''
        this.memberList = []
        this.memberAmount = 0
        document.getElementById('memberList').value = null
        miniToastr.error('會員名單解析失敗請檢查內容')
        this.$refs.invalidWindow.show()
        this.getInvalidList(1)
      } else {
        this.v_MemberList = true
        this.fileName = file.name
        this.memberList = uploadMembers
        this.memberAmount = this.memberList.length
        miniToastr.success('會員名單解析成功')
      }
    },
    getInvalidList (currentPage) {
      this.model1.currentPage = currentPage
      const startIndex = (this.model1.currentPage - 1) * this.model1.rows
      const endIndex = this.model1.currentPage * this.model1.rows
      let invalidArray = []
      if (endIndex < this.model1.totalrows) {
        invalidArray = this.invalidList.slice(startIndex, endIndex)
      } else {
        invalidArray = this.invalidList.slice(startIndex)
      }
      this.showInvalidList = invalidArray
      this.model1.startRowNum = (this.model1.totalrows === 0) ? 0 : startIndex + 1
      this.model1.endRowNum = (this.model1.totalrows === 0) ? 0 : (this.model1.totalrows < endIndex) ? this.model1.totalrows : endIndex
    },
    resetFile () {
      this.fileName = ''
      this.memberList = []
      this.memberAmount = 0
      document.getElementById('memberList').value = null
      this.v_MemberList = false
      this.invalidList = []
      this.model1.totalrows = 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/coupon/give/Add.vue